import styled from 'styled-components';

export const CarDocument = styled.button`
  display: flex;
  align-items: center;
  position: relative;
  margin: 8px;
  padding: 12px 28px;
  background-color: ${({ theme }) => theme.colors.gray800};
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  cursor: pointer;
  font-size: 40px;
  gap: 9px;
  flex: 1;
  min-width: 70%;

  img {
    width: 48px;
    height: 48px;
  }
`;

export const CarPicturesLabel = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  cursor: pointer;
  margin-top: 4px;
`;

export const ItemsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 4px;
`;

export const ItemsContainer = styled.li`
  width: 50%;
  padding: 8px;
`;

export const ItemCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 16px 0;
  background-color: ${({ theme }) => theme.colors.gray800};
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  position: relative;

  img {
    width: 48px;
    height: 48px;
  }
`;

export const ItemTitle = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  margin: 24px 0 14px 0;
`;

export const ItemDefContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ItemPartsCount = styled.label`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};

  span {
    font-size: 18px;
    margin: 0 4px;

    :before {
      background: -webkit-linear-gradient(rgba(64, 255, 175, 1), rgba(0, 184, 107, 1));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

export const ItemDefCount = styled.label`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.gray0};

  span {
    font-size: 18px;
    margin: 0 4px;

    :before {
      background: -webkit-linear-gradient(rgba(255, 52, 125, 1), rgba(255, 43, 43, 1));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
`;
